import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-shared-device-hint',
    templateUrl: './shared-device-hint.component.html',
    styleUrls: ['./shared-device-hint.component.scss'],
    standalone: false
})
export class SharedDeviceHintComponent {
  @Input() text = '';
}
